import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useGoogleLogin } from "@react-oauth/google";

const Login = () => {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      let msg = "Login failed. Please check your credentials.";

      if (err?.response?.data) {
        const data = err.response.data;
        if (data.detail) {
          msg = data.detail;
        } else if (data.non_field_errors) {
          msg = Array.isArray(data.non_field_errors)
            ? data.non_field_errors[0]
            : data.non_field_errors;
        } else {
          msg = Object.entries(data)
            .map(([key, value]) =>
              Array.isArray(value) ? value.join(" ") : value
            )
            .join(" ");
        }
      } else if (err.message) {
        msg = err.message;
      }

      setError(msg);
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    flow: "implicit", // get access_token directly
    onSuccess: async (tokenResponse) => {
      setError("");
      setLoading(true);
      try {
        // tokenResponse.access_token contains the access token you need to send to backend
        await loginWithGoogle(tokenResponse.access_token);
        navigate("/");
      } catch (err) {
        setError("Google login failed. Please try again.");
        console.error("Google login error:", err);
      } finally {
        setLoading(false);
      }
    },
    onError: () => setError("Google login failed. Please try again."),
  });

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-900">
      <h1 className="text-4xl font-bold text-purple-500">Login</h1>
      <form onSubmit={handleLogin} className="space-y-4 mt-8 w-72">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 bg-gray-800 text-white border border-gray-700 rounded"
          required
          disabled={loading}
          autoComplete="email"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 bg-gray-800 text-white border border-gray-700 rounded"
          required
          disabled={loading}
          autoComplete="current-password"
        />
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <button
          type="submit"
          className="w-full py-2 px-4 bg-purple-600 text-white rounded hover:bg-purple-700 disabled:opacity-50"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <div className="mt-6 w-72 text-center">
        <p className="mb-2 text-gray-300">Or sign in with Google</p>
        <button
          onClick={() => googleLogin()}
          className="w-full py-2 px-4 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
          disabled={loading}
        >
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default Login;
